import React, { useContext, useEffect, useState } from "react";
import ManageZoom from "../Helpers/ManageZoom/ManageZoom";
import PlayBackPositions from "./HistoryPositions/PlayBackPositions";
import { Helmet } from "react-helmet";
import Geofences from "../Geofences/Geofences";
import { popupcontext } from "../../context/Popupscontext";
import { useSelector } from "react-redux";
import Map from "../Maps/Map";
import PlayBackSelection from "./HistoryPlayBackSelection/PlayBackSelection";
import PlayBackTrip from "./HistoryPlayBackTrip/PlayBackTrip";
import ObjectMinimized from "../LiveTracking/Object/ObjectMinimized/ObjectMinimized";
import PlayBackTripMinimzed from "./HistoryPlayBackTrip/PlayBackTripMinimzed";
import PlayBackControls from "./HistoryPlay/PlayBackControls";

export default function PlayBack() {
	const historypositions = useSelector(
		(state) => state.webSocket.historypositions,
	);
	let { setDisplay, setShow, show } = useContext(popupcontext);
	const [startDate, setStartDate] = useState("");
	const [colors, setColors] = useState([]);
	const [endDate, setEndDate] = useState("");
	const [vid, setVId] = useState();
	const [playBackSpeed, setPlayBackSpeed] = useState(1);
	const [settings, setSettings] = useState({
		parkingPeriods: false,
		idlePeriods: false,
		centerTracker: false,
		mapPoints: false,
	});
	const [media, setMedia] = useState(false);
	const [minimzeAll, setMinimizeAll] = useState(false);
	const [minimzeMediaPlayer, setMinimizeMediaPlayer] = useState(false);
	const [playAllHist, setPlayAllHist] = useState(false);

	useEffect(() => {
		return () => setDisplay(false);
	}, [setDisplay]);
	useEffect(() => {
		setShow({ type: "playbackselection", value: true });
	}, [setShow]);
	let HistoryPlayBack = [];
	const type = (motion, ignition, protocol) => {
		if (protocol !== "osmand" && ignition !== undefined) {
			if (motion && ignition) {
				return "Moving";
			} else if (!motion && ignition) {
				return "Idle";
			} else if (!motion && !ignition) {
				return "Parking";
			}
		} else {
			if (motion) {
				return "Moving";
			} else if (!motion) {
				return "Parking";
			}
		}
	};
	historypositions.forEach((i) => {
		if (i.attributes.motion === true && i.attributes.ignition === false) {
			return;
		}

		const currentType = type(
			i?.attributes?.motion,
			i?.attributes?.ignition,
			i?.protocol,
		);
		if (
			HistoryPlayBack?.length === 0 ||
			HistoryPlayBack[HistoryPlayBack?.length - 1].type !== currentType
		) {
			HistoryPlayBack.push({ type: currentType, data: [i] });
		} else {
			const lastGroup = HistoryPlayBack[HistoryPlayBack?.length - 1];
			lastGroup.data.push(i);
		}
	});
	const calculateTakenTime = (startTime, endTime) => {
		const start = new Date(startTime);
		const end = new Date(endTime);
		const diffMs = end - start;

		const hours = Math.floor(diffMs / (1000 * 60 * 60));
		const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

		return `${hours}h ${minutes}m ${seconds}s`;
	};

	HistoryPlayBack = HistoryPlayBack.map((group, index) => {
		const firstTime = group?.data?.[0]?.fixTime;

		let lastTime;

		if (group?.data?.length === 1) {
			// Try to get the next group's first fixTime
			lastTime = HistoryPlayBack?.[index + 1]?.data?.[0]?.fixTime;

			// If no valid lastTime, fallback to firstTime to avoid NaN
			if (!lastTime) lastTime = firstTime;
		} else {
			// Last fixTime in the current group
			lastTime = group?.data?.[group.data.length - 1]?.fixTime;
		}

		const takenTime = calculateTakenTime(firstTime, lastTime);
		return { ...group, takenTime };
	});

	return (
		<>
			<Helmet>
				<title>History Playback</title>
				<meta name="description" content="History Playback" />
			</Helmet>
			<Map>
				<PlayBackPositions
					startDate={startDate}
					endDate={endDate}
					vid={vid}
					HistoryPlayBack={HistoryPlayBack}
					mainhistorypositions={historypositions}
					setColors={setColors}
					playBackSpeed={playBackSpeed}
					settings={settings}
				/>
				<Geofences />
				<ManageZoom>
					{show.type === "playbackselection" && show.value === true && (
						<>
							<PlayBackSelection
								setStartDate={setStartDate}
								startDate={startDate}
								setEndDate={setEndDate}
								endDate={endDate}
								setVId={setVId}
								vid={vid}
								media={media}
								setMedia={setMedia}
							/>
						</>
					)}

					{show?.type === "playbacktrip" && show?.value === true && media && (
						<>
							{minimzeAll === false && (
								<PlayBackTrip
									setStartDate={setStartDate}
									startDate={startDate}
									setEndDate={setEndDate}
									endDate={endDate}
									vid={vid}
									HistoryPlayBack={HistoryPlayBack}
									mainhistorypositions={historypositions}
									colors={colors}
									setPlayBackSpeed={setPlayBackSpeed}
									settings={settings}
									setSettings={setSettings}
									media={media}
									setMedia={setMedia}
									setMinimizeAll={setMinimizeAll}
									setMinimizeMediaPlayer={setMinimizeMediaPlayer}
									minimzeMediaPlayer={minimzeMediaPlayer}
									setPlayAllHist={setPlayAllHist}
									setVId={setVId}
								/>
							)}
						</>
					)}
					{minimzeAll && (
						<ObjectMinimized
							title="object"
							name="Playback"
							minimize={() => {
								setMinimizeAll(false);
								setMedia(true);
							}}
						/>
					)}
					<div className="text-center">
						{playAllHist && historypositions?.length > 0 && (
							<>
								<PlayBackControls
									maxValue={historypositions?.length}
									setPlayAllHist={setPlayAllHist}
									setPlayBackSpeed={setPlayBackSpeed}
									minimzeMediaPlayer={minimzeMediaPlayer}
									setMinimizeMediaPlayer={setMinimizeMediaPlayer}
									setMedia={setMedia}
								/>
							</>
						)}
					</div>
					{/**<PlayBackTable />**/}
				</ManageZoom>
			</Map>
		</>
	);
}
